const text = {
  about_me: ``,
  workCategories: {
    title: `My Background`,
    intro: "As a software engineer, I'm active in these areas...",
    fields: [
      {
        title: `Front End Engineer`,
        description: `Experienced in the full software development cycle including Planning, Analysis, Design, Implementation, Automation Testing, and Maintenance.`
      },  
      {
        title: `Software Architect`,
        description: `Architecting projects with server, web and mobile client API's with different Javascript Libraries/Frameworks. React JS, Angular JS, Vue JS`
      },
      {
        title: `Back End Engineer`,
        description: `Designing and developing several servers with Node.js, ASP.NET MVC and ASP.NET Core. \n Docker, CI, Azure DevOps`
      },
      {
        title: `Microsoft Stack Developer`,
        description: `C#, VB.NET, Windows Forms and WPF expert.`
      },
      {
        title: `RDBMS and Sql Designer`,
        description: `Designing and building several DataBases with MS SQL Server, My SQL, MongoDB and etc.`
      },
      {
        title: `Start Up Expert`,
        description: `Creating Applications from scratch. Familiar with small business start up environments.`
      }
    ]
  }
};

export default text;
